import Result from "@/core/common/Result";

export type PesquisaCSATAtivaResponse = {
  pesquisaCSATId: string;
  ativa: boolean;
  ignorada: boolean;
  respondida: boolean;
  primeiroAcesso: boolean;
};

export type PesquisaCSATAtivaParams = {
  pagina: string;
};

export interface IPesquisaCSATAtivaGateway {
  pesquisaAtiva(
    params: PesquisaCSATAtivaParams
  ): Promise<Result<PesquisaCSATAtivaResponse>>;
}
export const pesquisaCSATAtivaGatewayDI = "pesquisaCSATAtivaGateway";
